var $ = jQuery
var changedCart = false

document.addEventListener("DOMContentLoaded", function() {
  const mainHeader = document.getElementById("main-header");
  const fixedHeader = document.getElementById("fixed-header");

  window.addEventListener("scroll", function() {
    if (window.scrollY > 150) {
      fixedHeader.classList.remove("hidden");
    } else {
      fixedHeader.classList.add("hidden");
    }
  });
});

// Função para atualizar informações do carrinho
function updateCartInfo() {
  let allItemsQuantity = 0
  let allItemsPrice = 0

  $('.niceQtt').each(function() {
    let flavor = $(this).data('flavor')
    
    if ( $(this).val() == 0 ) {
      $(`.productCard.${flavor}`).find('.removeQtt').prop("disabled", true)
    } else {
      $(`.productCard.${flavor}`).find('.removeQtt').prop("disabled", false)
    }
    allItemsQuantity += parseInt( $(this).val() )
  })

  if (allItemsQuantity == 0) {
    document.getElementById('cart-quantity').textContent = `0 item`;
    document.getElementById('cart-total').textContent = `R$ 0,00`;
    $('#checkout-button').prop("disabled", true)
    return false
  }
  
  let price = allItemsQuantity < 10 ? 5.00 :
              allItemsQuantity >= 10 && allItemsQuantity < 50 ? 4.00 :
              3.50
  allItemsPrice = allItemsQuantity * price
  $('#checkout-button').prop("disabled", false)

  document.getElementById('cart-quantity').textContent = `${allItemsQuantity} itens`;
  document.getElementById('cart-total').textContent = `R$ ${allItemsPrice.toFixed(2)}`;
}

if ($('#checkout-button').length > 0) {
  document.querySelector('#checkout-button').addEventListener('click', function (e) {
    e.preventDefault();

    if (!changedCart) {
      window.location.href = cart_link;
    }

    // Capturar os dados dos inputs
    const inputs = document.querySelectorAll('.niceQtt');
    const products = {};

    inputs.forEach(input => {
      const productId = input.dataset.productId; // Assumindo que o ID do produto está no atributo data-product-id
      const quantity = parseInt(input.value, 10);

      if (quantity > 0) {
        products[productId] = quantity;
      }
    });

    $.ajax({
      url : woocommerce_params.ajax_url,
      data : {
          action : 'add_multiple_products_to_cart',
          products: products,
          security: woocommerce_params.ajax_nonce,
      },
      method : 'POST', //Post method
      success : function( response ){
          if (response.success) {
              window.location.href = response.data.redirect_url;
          } else {
              console.error('Erro ao adicionar produtos ao carrinho:', response.data);
              alert('Ocorreu um erro ao adicionar os produtos ao carrinho.');
          }
      },
      error : function(error){ console.log(error) }
    })
  });
}

function loadCartProducts() {
  $.ajax({
    url: woocommerce_params.ajax_url, // URL do admin-ajax.php
    method: 'POST',                  // Método HTTP
    dataType: 'json',                // Tipo de retorno esperado
    data: {
      action: 'get_cart_products', // Nome da ação definida no PHP
      nonce: woocommerce_params.ajax_nonce // Nonce de segurança
    },
    success: function (response) {
      if(response.success) {
        response.data.forEach(( item, index ) => {
          $(`input[data-product-id='${item.id}']`).val( item.quantity )
          if ( index == response.data.length - 1) updateCartInfo()
        })
      }
    },
    error: function (error) {
      console.error('Erro ao carregar os produtos:', error);
    }
  });
}

$(document).ready(function() {
  if ( !$('body').hasClass('home') ) return false

  loadCartProducts()

  $(document.body).on('click', '.removeQtt', function() {
    changedCart = true
    let flavor = $(this).data('flavor')
    let inputQtt = $(`#niceQtt_${flavor}`)
    let curVal = parseInt( inputQtt.attr('value') )
    let newVal = curVal - parseInt( $(this).data('quantity') )
    if ( newVal == 0 ) $(`.productCard.${flavor}`).find('.removeQtt').prop("disabled", true)
    inputQtt.attr('value', newVal)
    updateCartInfo()
  })
  $(document.body).on('click', '.addQtt', function() {
    changedCart = true
    let flavor = $(this).data('flavor')
    let inputQtt = $(`#niceQtt_${flavor}`)
    let curVal = parseInt( inputQtt.attr('value') )
    let newVal = curVal + parseInt( $(this).data('quantity') )
    $(`.productCard.${flavor}`).find('.removeQtt').prop("disabled", false)
    inputQtt.attr('value', parseInt(newVal) )
    updateCartInfo()
  })
  $(document.body).on('click', '.resetQtt', function() {
    changedCart = true
    let flavor = $(this).data('flavor')
    let inputQtt = $(`#niceQtt_${flavor}`)
    $(`.productCard.${flavor}`).find('.removeQtt').prop("disabled", true)
    inputQtt.attr('value', parseInt(0) )
    updateCartInfo()
  })
})
